module.exports = __webpack_public_path__ + "img/lbl01.68100eab.png";